import { createAction, props } from '@ngrx/store';

export const SetSubdomain = createAction(
  '[Root] - Set current subdomain',
  props<{ subdomain: string }>(),
);
